var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { CircularProgress, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, useTheme } from "@mui/material";
import { useMutation } from "react-query";
import { ProfileAiService } from "../../services/profile/profileAi.service";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useSnackbar } from 'notistack';
import { isSameDay } from "../../utils/date.util";
var ProfileListAiAction = function (_a) {
    var _b, _c;
    var profile = _a.profile, refreshList = _a.refreshList, setHighlightedInterests = _a.setHighlightedInterests, setHighlightedRecommendations = _a.setHighlightedRecommendations;
    var t = useTranslation().t;
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var open = Boolean(anchorEl);
    var theme = useTheme();
    var handleOpenMenu = function (event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var profileFullName = [
        ((_b = profile.academicTitle) === null || _b === void 0 ? void 0 : _b.trim()) || ((_c = profile.namePrefix) === null || _c === void 0 ? void 0 : _c.trim()),
        profile.firstName,
        profile.lastName
    ].filter(Boolean).join(' ');
    var handleCloseMenu = function () { return setAnchorEl(null); };
    var aiMutation = useMutation({
        mutationFn: function () { return ProfileAiService.enrichInterests(profile.id); },
        onSuccess: function (data) {
            if (!data) {
                console.log('ai response interests', data);
                enqueueSnackbar(t("No interests found for", {
                    name: profileFullName !== null && profileFullName !== void 0 ? profileFullName : "",
                }), { variant: 'warning' });
            }
            else {
                enqueueSnackbar(t("Interests enriched for", {
                    name: profileFullName,
                }), { variant: 'success' });
                setHighlightedInterests === null || setHighlightedInterests === void 0 ? void 0 : setHighlightedInterests(data);
            }
            refreshList();
        },
        onError: function () {
            enqueueSnackbar(t("Failed to enrich interests for", { name: profileFullName }), { variant: 'error' });
        }
    });
    var aiMutationRecommendations = useMutation({
        mutationFn: function () { return ProfileAiService.enrichRecommendations(profile.id); },
        onSuccess: function (data) {
            if (!data) {
                enqueueSnackbar(t("No recommendations found for", { name: profileFullName }), { variant: 'warning' });
            }
            else {
                enqueueSnackbar(t("Recommendations enriched for", {
                    name: profileFullName,
                }), { variant: 'success' });
                setHighlightedRecommendations === null || setHighlightedRecommendations === void 0 ? void 0 : setHighlightedRecommendations(data);
            }
            refreshList();
        },
        onError: function () {
            enqueueSnackbar(t("Failed to enrich recommendations for", { name: profileFullName }), { variant: 'error' });
        }
    });
    var latestRecommendationToday = function () {
        var _a, _b, _c;
        var recommendations = (_a = profile.smartData) === null || _a === void 0 ? void 0 : _a.recommendations;
        var latestRecommendationDate = (_b = profile.latestRecommendationDate) !== null && _b !== void 0 ? _b : (_c = recommendations === null || recommendations === void 0 ? void 0 : recommendations[recommendations.length - 1]) === null || _c === void 0 ? void 0 : _c.date;
        return latestRecommendationDate
            ? isSameDay(new Date(latestRecommendationDate), new Date())
            : false;
    };
    var isLoading = aiMutation.isLoading || aiMutationRecommendations.isLoading;
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ size: "small", onClick: handleOpenMenu, "data-testid": "ai-actions-button", style: {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    padding: 8,
                    borderRadius: theme.shape.borderRadius,
                    boxShadow: theme.shadows[2],
                    width: 32,
                    height: 32,
                } }, { children: isLoading ? (_jsx(CircularProgress, { size: 16, thickness: 5, style: { color: theme.palette.primary.contrastText } })) : (_jsx(AutoAwesomeIcon, { fontSize: "small" })) })), _jsxs(Menu, __assign({ anchorEl: anchorEl, open: open, onClose: handleCloseMenu, onClick: function (e) { return e.stopPropagation(); } }, { children: [_jsxs(MenuItem, __assign({ onClick: function () {
                            aiMutation.mutate();
                            handleCloseMenu();
                        }, disabled: aiMutation.isLoading, "data-testid": "ai-interests-button" }, { children: [_jsx(ListItemIcon, { children: _jsx(AutoAwesomeIcon, { fontSize: "small" }) }), _jsx(ListItemText, { children: t("AI Interests") })] })), _jsxs(MenuItem, __assign({ onClick: function () {
                            aiMutationRecommendations.mutate();
                            handleCloseMenu();
                        }, disabled: aiMutationRecommendations.isLoading || latestRecommendationToday(), "data-testid": "ai-recommendations-button" }, { children: [_jsx(ListItemIcon, { children: _jsx(AutoAwesomeIcon, { fontSize: "small" }) }), _jsx(ListItemText, { children: t("AI Recommendations") })] }))] }))] }));
};
export default ProfileListAiAction;
